import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    background-color: #f3f3f3;
    border-top: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    position: relative;
    margin-bottom: 20px;

    .search {
      padding: 20px 15px;
      min-height: 34px;
      vertical-align: middle;
    }
  }
`;

const SearchWrapDiv = ({ children, className }) => {
  return (
    <StyledDiv className={className}>
      <div className="search">{children}</div>
    </StyledDiv>
  );
};

export default SearchWrapDiv;
